// packages/game/src/objects/diceThrowConfig.ts
//
// Tunables and feature flags for the physical dice throw.
// Adjusted during playtest; values come from the design spec.

export const CHIP_SCATTER_ENABLED = false;

export const PHYSICS = {
  wallRestitution: 0.65,
  pairRestitution: 0.98,        // dice-vs-dice — near-elastic so held dice keep rattling
  diceChipRestitution: 0.55,
  linearDampingPerSec: 0.15,    // multiplicative: vel *= damping^dt — felt friction
  angularDampingPerSec: 0.05,   // dice stop spinning quickly on a felt surface
  lowSpeedThreshold: 200,       // px/s — below this, extra friction kicks in
  lowSpeedDampingPerSec: 0.005, // multiplicative per-sec, applied alongside normal damping
  lowSpeedAngDampingPerSec: 0.005,
  settleVelThreshold: 50,       // px/s
  settleAngVelThreshold: 1.5,   // rad/s
  settleFrames: 6,
  hardTimeoutSec: 5,
  impactSpeedThreshold: 0,      // px/s — every wall touch fires onImpact; intensity scales in the handler
  diceMass: 4,
  chipMass: 1,
} as const;

export const GESTURE = {
  fingerVelocityWindowMs: 100,
  tapDragThresholdPx: 12,       // total finger displacement below this = tap (vs flick)
  tapVelocityThreshold: 80,     // px/s — legacy: still exported for any external reader
  tapBaselineYFactor: 6.0,      // baseline upward velocity = sqrt(2 * g * H * factor); tuned so taps settle below the roll-name flash band
  gravity: 0,                   // top-down view: no gravity. Throw motion is pure inertia + damping.
  pickUpLiftPx: 8,              // visual lift on grab
  pickupTorqueRad: 14,          // peak |angVel| applied to each die on grab (rad/s)
  grabFidgetPx: 14,             // ±range of per-frame spring-target jitter while held
  grabOrbitRadiusPx: 28,        // each die's spring target orbits this far from finger
  grabOrbitRadPerSec: 9,        // angular speed of the orbital separation (rad/s)
  springStiffness: 800,         // F = k*(target-pos) - c*vel
  springDamping: 30,            // moderate underdamped → visible wobble
  faceFlickerIdleMs: 70,
  faceFlickerShakeMs: 35,
  shakeFingerVelocity: 250,     // px/s lateral velocity threshold for "shaking"
  perDieJitterPx: 8,            // random offset on launch so dice diverge
  perDieAngVelJitterRad: 18,    // random spin on launch (peak ±18 rad/s)
  settleHoldSec: 0.75,          // hold settled dice this long before returning home
  returnTweenMs: 380,
  returnEase: 'Cubic.easeOut',
} as const;

export const DEPTH = {
  diceThrow: 1000,              // bumped above zones, chips, rack while in flight
} as const;
